import { render } from "./PointNotificationPanelSmall.vue?vue&type=template&id=18860fc5&scoped=true"
import script from "./PointNotificationPanelSmall.vue?vue&type=script&lang=js"
export * from "./PointNotificationPanelSmall.vue?vue&type=script&lang=js"

import "./PointNotificationPanelSmall.vue?vue&type=style&index=0&id=18860fc5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18860fc5"]])

export default __exports__